module.exports = __webpack_public_path__ + "assets/user.713c7fa7.svg";